var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-wrapper[data-v-43931f28] {\n  display: flex;\n  flex-direction: column;\n}\n.app[data-v-43931f28] {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  flex: 1;\n}\n.app-content[data-v-43931f28] {\n  flex: 1 0 auto;\n}\n.eoi-bg[data-v-43931f28] {\n  background-image: url(" + escape(require("../img/eoi/eoi_background_img.jpg")) + ");\n  background-size: cover;\n  background-position: center;\n}\n.eoi-bg__thankyou[data-v-43931f28] {\n  background-position-y: 50%;\n}", ""]);

// exports
